export default "__VITE_ASSET__x258gSOM__"